<div class="queue">
 <div class="toolbar"><strong>{{rows.length}} SKUs need a price update</strong><button mat-icon-button (click)="refresh()" aria-label="Refresh SKU updates" [disabled]="loading"><mat-icon>refresh</mat-icon></button></div>
 <input class="search" aria-label="Find SKU or reference" placeholder="Find coffee, SKU, or reference" [(ngModel)]="search">
 @if(error){<p role="alert">{{error}}</p>}
 @if(loading&&!rows.length){<p role="status">Loading SKU updates…</p>}
 @if(!loading&&!error&&!rows.length){<p class="empty">SKU pricing is up to date.</p>}
 <div class="items">
 @for(row of items;track row.InventoryTypeID){
  <article><button class="coffee" (click)="open(row)">{{row.InventoryTypeName}}</button><small>SKU {{row.InventoryTypeID}} · Last updated {{row.LastPriceDate ? (row.LastPriceDate | date:'MMM d, yyyy') : 'Never'}}</small>
  @if(row.Overdue){<span class="reason">{{row.LastPriceDate ? '30+ days since pricing update' : 'No pricing update recorded'}}</span>}
  @if(references(row,'transfer');as refs){<span class="reason">Transfer added · Ref {{refs}}</span>}
  @if(references(row,'misc-adjustment');as refs){<span class="reason">Misc adjustment added · Ref {{refs}}</span>}
  </article>
 }
 </div>
 <button mat-stroked-button (click)="open()">Open SKU Pricing</button>
</div>
